// extracted by mini-css-extract-plugin
export default {"tab":"categoryFeatureView_tab__dfiQo"};